
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'FAB_classification_of_myelodysplastic_syndrome',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/FAB_classification_of_myelodysplastic_syndrome.vue